const disableSubTree = (node: any) => {
  node.disabled = true
  if (node.children && node.children.length) {
    node.children.forEach(disableSubTree)
  }
}

export const formatTreeSelect = ({
  tree,
  disabledKey = null,
  disableSub = true,
  parentPath = '',
  keyPath = '',
  level = 1,
}: {
  tree: any[]
  disabledKey?: string | null
  disableSub?: boolean
  parentPath?: string
  keyPath?: string
  level?: number
}) => {
  const result = JSON.parse(JSON.stringify(tree))
  return result.map((item) => {
    item.key = item.id
    item.value = item.id
    item.level = level
    item.title = `${item.code} ${item.name}`
    // Add fullPath property to each node
    item.fullPath = parentPath ? `${parentPath}/${item.title}` : item.title
    item.keyPath = keyPath ? `${keyPath}/${item.key}` : `${item.key}`

    if (item.children && item.children.length) {
      item.children = formatTreeSelect({
        tree: item.children,
        disabledKey,
        disableSub,
        parentPath: item.fullPath,
        keyPath: item.keyPath,
        level: level + 1,
      })
    }

    if (item.key === disabledKey) {
      if (disableSub) {
        disableSubTree(item)
      } else {
        item.disabled = true
      }
    }
    return item
  })
}

// 找到所有非叶子节点的key
export const findParentKeys = (list: any[], key: string) => {
  const keys: any[] = []
  list.forEach((item) => {
    if (item.children && item.children.length) {
      keys.push(item[key])
      keys.push(...findParentKeys(item.children, key))
    }
  })
  return keys
}

export const findNode = (tree: any, key: string | number) => {
  let node = null
  for (let i = 0; i < tree.length; i++) {
    if (tree[i].id === key) {
      return tree[i]
    }
    if (tree[i].children && tree[i].children.length) {
      node = findNode(tree[i].children, key)
      if (node) {
        return node
      }
    }
  }
  return node
}

export const formaMeddratLltData = ({
  tree,
  level = 1,
}: {
  tree: any[]
  level?: number
}) => {
  const result = JSON.parse(JSON.stringify(tree))
  return result.map((item, index) => {
    item.level = level
    item.key = `${item.code}-${level}-${index}`
    if (item.children && item.children.length) {
      item.children = formaMeddratLltData({
        tree: item.children,
        level: level + 1,
      })
    }
    return item
  })
}
